RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Delete = Marionette.ItemView.extend({
        template: '#accountDeleteTemplate',

        ui: {
            deleteBtn: '.btn-danger'
        },

        events: {
            'click @ui.deleteBtn': 'delete'
        },

        delete: function () {
            const me = this;
            me.ui.deleteBtn.button('loading');

            me.model.destroy({
                success: function () {
                    me.$el.find('.modal').modal('hide');
                }
            }).fail(me.showError);
        },

        showError: function () {
            this.$('.alert').show();
        }
    });
});
